import { Box, Typography } from '@mui/material';

export default function ToastMessage({ title, subtitle }) {
  return (
    <Box sx={{ display: 'flex', flexFlow: 'column' }}>
      <Typography sx={{ fontWeight: 'bold', fontSize: '14px' }}>
        {title}
      </Typography>
      <Typography sx={{ fontSize: '13px' }}>{subtitle}</Typography>
    </Box>
  );
}
